<template>
  <div class='lm-product-intro'>
    <h2>MoPaaS 大模型 AI 培训项目的学员覆盖了企业高管、政府官员、研究人员、AI 架构师、产品经理以及技术主管等不同背景。培训内容目标明确，包括以下几个方面：
    </h2>
    <div class="grid">
      <div class="grid-item">
        <div class="text">
          <p>·大模型基础知识</p> 
          <p>1.掌握 AI 和大模型的基本原理；</p>
          <p>2.理解大模型的应用逻辑和典型场景；</p>
          <p>3.熟悉当今主流的大模型架构。</p>
        </div>
      </div>
      <div class="grid-item">
        <div class="text">
          <p>·大模型应用开发</p>
          <p>1.掌握大模型应用选型的关键要点；</p>
          <p>2.深入学习提示工程、RAG（检索增强生成）和智能体（Agent）等技术；</p>
          <p>3.通过真实项目实战，掌握大模型应用系统的开发方法。</p>
        </div>
      </div>
      <div class="grid-item">
        <div class="text">
          <p>·大模型训练工程 </p> 
          <p>1.理解大模型的预训练与二次训练原理；</p>
          <p>2.掌握并行训练技术（如 DeepSpeed）和专家混合技术（MoE）。</p>
        </div>
      </div>
      <div class="grid-item">
        <div class="text">
          <p>·大模型微调适配</p> 
          <p>1.学习大模型微调技术选项；</p>
          <p>2.掌握 PEFT 微调（参数高效微调）及 LoRA 等核心技术；</p>
          <p>3.理解基于人工反馈的强化学习方法。</p>
        </div>
    </div>
      <div class="grid-item">
        <div class="text">
          <p>·大模型安全与对齐</p> 
          <p>1.识别生成式大模型在安全性和价值对齐方面的潜在问题；</p>
          <p>2.基本的安全对齐技术，确保负责任的模型使用，减少偏见，防范滥用。</p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="content">为实现这一目标，MoPaaS 通过 AI 加速闭环生态整合多方资源，推动大模型 AI 人才培养计划的高效落地。合作伙伴包括智学优课、清华大学、华东理工大学、上海交通大学、西湖大学、美国加州科技大学 (CSTU)、中关村人工智能学院、上海科技网以及联合国世界数字技术研究院 (WDTA) 等知名机构和高校。</div>
      <div class="content">其中，智学优课作为一家专注 IT 人才培养的线上教育机构，其培训方向覆盖人工智能、大模型、网络安全、编程语言、安卓 APP 开发和前端开发等，累计培养了超十万泛 IT 人才。MoPaaS 与智学优课联合打造的在线教育品牌“智泊 AI”，标志着 MoPaaS 正式迈入培训业务领域。</div>
      <div class="content">凭借多年在 AI 技术、产品和业务领域的深厚积累，MoPaaS 能够以更贴近实际应用的方式为企业和机构合作伙伴提供赋能，同时帮助学员通过多样化的培训模式掌握前沿 AI 技术，提升自己的技能、更好地服务于其所在组织。</div>
      <div class="content">作为中国人工智能产业的重要参与者，MoPaaS 始终致力于普及 AI 和大模型应用技术，培养高质量的 AI 人才。此次在线教育业务的启动，标志着 MoPaaS 成功建立了涵盖大模型人才培训、项目教练、应用共建、技术平台等全方位服务的大模型 AI 应用加速闭环，助力合作伙伴以低成本、高效率推动大模型应用的全面落地。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LmIntrodution'
}
</script>

<style>
.lm-product-intro {
  background: #F5F6F9;
  padding: 6vw 3vw;
}
.lm-product-intro .grid-item {
    width: 83vw;
    height: 36vw;
    background-image: url("../../assets/images/bg_edu_grid.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: left;
    align-items: center;
    padding: 0 19px;
  }
  .lm-product-intro .grid-item .text p {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
  }

.lm-product-intro h2 {
  margin: 0 auto 6vw;
  font-size: 14px;
  font-weight: 600;
  color: #3A3F4D;
  line-height: 18px;
  text-align: left;
}

.lm-product-intro .box {
  width: 96vw;
}

.lm-product-intro .box img {
  width: 94vw;
  height: 55vw;
  margin-top: 2vh;
}
.lm-product-intro .content {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  text-align: left;
  margin: 4vw 2vw 0;
}
</style>
<style>.grid {display: grid;}
</style>


// WEBPACK FOOTER //
// src/page/h5/edu-introduction.vue